<template>
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <slot name="body">
            No Content in Slot
          </slot>
        </v-card-text>
        <v-card-actions>
          <slot name="actions">
            No actions
          </slot>
        </v-card-actions>
      </v-card>
</template>

<script>
export default {
  props: [
    'title'
  ]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue